const data = [
    {
        id: "hdI2bqOjy3c",
        name:
            "JavaScript Crash Course For Beginners",
        uploadedBy: " Traversy Media",
        thumbnail: "https://i.ytimg.com/vi_webp/hdI2bqOjy3c/mqdefault.webp",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwng963DN2_MIbKuvMWRrN4KG920h3Y4YHg6KET9vZg=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "Ke90Tje7VS0",
        name: "React JS - React Tutorial for Beginners",
        uploadedBy: " Programming with Mosh",
        thumbnail: "https://i.ytimg.com/vi_webp/Ke90Tje7VS0/mqdefault.webp",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwnj82Lirw0dg6V5pJWAcWdG22OESyldUcDwAFEqQWg=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "rfscVS0vtbw",
        name: "Learn Python - Full Course for Beginners [Tutorial]",
        uploadedBy: " freeCodeCamp.org",
        thumbnail: "https://i.ytimg.com/vi_webp/rfscVS0vtbw/mqdefault.webp",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwnifaQZvAunS0OFb2y_cieoVjLCVjqQW8Exf3BC1gg=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "hBh_CC5y8-s",
        name: "Java Full Course | Java Tutorial for Beginners | Java Online Training | Edureka",
        uploadedBy: " edureka!",
        thumbnail: "https://i.ytimg.com/vi_webp/hBh_CC5y8-s/mqdefault.webp",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwni7i_dF9urC5uwdLIRQU89f5H4krFAgJgywql8kiA=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "j8nAHeVKL08",
        name: "Introduction to C++, Installing VS Code, g++ & more | C++ Tutorials",
        uploadedBy: " CodeWithHarry",
        thumbnail: "https://i.ytimg.com/vi/yGB9jhsEsr8/mqdefault.jpg",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwnjeHnMHZ7T341QLHqPhQPfsG6ugvg_SV6z6FkYqGw=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "5LYrN_cAJoA",
        name: "Vue JS 2 Tutorial #1 - Introduction",
        uploadedBy: " The Net Ninja",
        thumbnail: "https://i.ytimg.com/vi/qZXt1Aom3Cs/mqdefault.jpg",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwni-Wm0ZBDYJYFwySP2esxgc8s9mKiwmI3yJrmjlHQ=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "0eWrpsCLMJQ",
        name: "Angular Tutorial - 1 - Introduction",
        uploadedBy: " Codevolution",
        thumbnail: "https://i.ytimg.com/vi/0eWrpsCLMJQ/mqdefault.jpg",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwnj5vbwTemGpOuabZnfkl_tDzb_Fldf_CSMW2cg3=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "XBj_le81sAc",
        name:
            "Introduction To PHP | Procedural PHP Tutorial For Beginners | PHP Tutorial | mmtuts",
        uploadedBy: " Dani Krossing",
        thumbnail: "https://i.ytimg.com/vi/XBj_le81sAc/mqdefault.jpg",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwnhnGW-L982DVkS9_1rpwPYq_X8xZ-_lMbs2hUE8pw=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "OTmQOjsl0eg",
        name:
            "Django Tutorial for Beginners | Full Course",
        uploadedBy: " Telusko",
        thumbnail: "https://i.ytimg.com/vi_webp/OTmQOjsl0eg/mqdefault.webp",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwnge5NyVX7anyIFrIaWVfxpyOfJifDHzMAU5GMmA=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "MwZwr5Tvyxo",
        name:
            "Python Flask Tutorial: Full-Featured Web App Part 1 - Getting Started",
        uploadedBy: " Corey Schafer",
        thumbnail: "https://i.ytimg.com/vi/MwZwr5Tvyxo/mqdefault.jpg",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwngomgNvn2XgfFWEVlxCl_tUVEOhmUTUTlesdnuD=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "DfslJ-kaZXA",
        name: "Introduction to Laravel",
        uploadedBy: " Geeky Shows",
        thumbnail: "https://i.ytimg.com/vi_webp/DfslJ-kaZXA/mqdefault.webp",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwnjqn9YY8ceZx27F-ZB92vXtolHID7OE7zMCBeBYEw=s48-c-k-c0x00ffffff-no-rj"
    },
    {
        id: "msXL2oDexqw",
        name: "Spring Boot Quick Start 1 - Introduction",
        uploadedBy: "Java Brains",
        thumbnail: "https://i.ytimg.com/vi/msXL2oDexqw/mqdefault.jpg",
        avatarSrc:
            "https://yt3.ggpht.com/ytc/AAUvwnjlYpnCSPVT12tGMSwpQLXja-PQOwl83_TJTcrCbA=s48-c-k-c0x00ffffff-no-rj"
    }
];

export default data